export default {

  //====================================弹窗提示================================
  "去维护": "去维护",
  "我知道了": "我知道了",
  "微信": "微信",
  "支付宝": "支付宝",
  "银行卡": "银行卡",
  "平台对您的需求抽成比例为": "平台对您的需求抽成比例为",
  "如果对此比例有疑问，请联系电话18811961666商讨或不要发布任何需求": "如果对此比例有疑问，请联系电话18811961666商讨或不要发布任何需求",
  "我们注意到您目前还未维护以下收款方式（": "我们注意到您目前还未维护以下收款方式（",
  "）, 请在交易前维护好收款方式以获得交易利润": "）, 请在交易前维护好收款方式以获得交易利润",
  //====================================素材库================================
  "素材库": "素材库",
  "新建": "新建",
  "新建文件夹": "新建文件夹",
  "返回上一级": "返回上一级",
  "商品文件夹": "商品文件夹",
  "重命名": "重命名",
  "输入新名称": "输入新名称",
  "输入文件夹名": "输入文件夹名",
  "素材库使用协议": "素材库使用协议",
  "我同意": "我同意",
  "裁剪图片": "裁剪图片",

  //====================================消息================================
  "我的消息": "我的消息",
  "消息中心": "消息中心",
  "需求方收件箱": "需求方收件箱",
  "供应方收件箱": "供应方收件箱",
  "协调方收件箱": "协调方收件箱",
  "标为已读": "标为已读",
  "全部标为已读": "全部标为已读",
  "标签": "标签",
  //====================================需求方--结账================================
  "结账": "结账",
  "选择收货地址": "选择收货地址",
  "选择付款方式": "选择付款方式",
  "微信支付": "微信支付",
  "中国的微信支付，需要使用微信APP扫码支付": "中国的微信支付，需要使用微信APP扫码支付",
  "支付宝支付": "支付宝支付",
  "中国的支付宝支付，需要使用支付宝APP扫码支付": "中国的支付宝支付，需要使用支付宝APP扫码支付",
  "银行卡中国方支付": "银行卡中国方支付",
  "请选择一个丝迈官方的中国银行卡，并往里面汇款，汇款时请在附言或备注栏注明订单号，需求ID或费用说明等关键信息以供平台快速结算，需要等待平台对转账金额确认后，订单才能继续": "请选择一个丝迈官方的中国银行卡，并往里面汇款，汇款时请在附言或备注栏注明订单号，需求ID或费用说明等关键信息以供平台快速结算，需要等待平台对转账金额确认后，订单才能继续",
  "个人银行卡转账": "个人银行卡转账",
  "企业银行卡转账": "企业银行卡转账",
  "银行卡国际方支付": "银行卡国际方支付",
  "请选择一个丝迈官方的国际银行卡，并往里面汇款，汇款时请在附言或备注栏注明订单号，需求ID或费用说明等关键信息以供平台快速结算，需要等待平台对转账金额确认后，订单才能继续": "请选择一个丝迈官方的国际银行卡，并往里面汇款，汇款时请在附言或备注栏注明订单号，需求ID或费用说明等关键信息以供平台快速结算，需要等待平台对转账金额确认后，订单才能继续",
  "在你需要协调或担保时，请选择平台提供的协调服务，平台将为您配备专业的协调员，帮助您解决交易中的问题。在没有选择协调服务的交易下所造成的损失，将由需求方自己承担": "在你需要协调或担保时，请选择平台提供的协调服务，平台将为您配备专业的协调员，帮助您解决交易中的问题。在没有选择协调服务的交易下所造成的损失，将由需求方自己承担",
  "商品与运输": "商品与运输",
  "订单摘要": "订单摘要",
  "项目": "项目",
  "订单总额": "订单总额",
  "如果您选择了协调服务，在后续可能还会支付给协调员一定的协调费和商品运费，具体的协调费用与运费请与协调员在后续约定金额": "如果您选择了协调服务，在后续可能还会支付给协调员一定的协调费和商品运费，具体的协调费用与运费请与协调员在后续约定金额",
  "我已付款": "我已付款",
  //====================================商品卡片================================
  "过去一个月有": "过去一个月有",
  "顾客购买": "顾客购买",
  "元": "元",
  "已售": "已售",
  "物流": "物流",
  "发货地": "发货地",
  "配送到": "配送到",
  "数量": "数量",
  "产品说明": "产品说明",
  "顾客评论": "顾客评论",
  "条全球评论": "条全球评论",
  "星": "星",
  "查看商店": "查看商店",
  "商品种类": "商品种类",
  "开始项目": "开始项目",
  "天完成项目": "天完成项目",
  "点击查看完成视图": "点击查看完成视图",
  "没有详细信息": "没有详细信息",
  //====================================订单追踪================================
  "订单编号": "订单编号",
  "规格": "规格",
  "结算金额": "结算金额",
  "运至": "运至",
  "收货人": "收货人",
  "购买日期": "购买日期",
  "发货时间": "发货时间",
  "订单当前状态": "订单当前状态",
  "发货人": "发货人",
  "物流单号": "物流单号",
  "历史记录": "历史记录",
  //====================================收货地址/发货地址================================
  "默认": "默认",
  "添加一个新地址": "添加一个新地址",
  "输入新的收货地址": "输入新的收货地址",
  "输入新的发货地址": "输入新的发货地址",
  "添加新地址": "添加新地址",
  "国家/地区": "国家/地区",
  "请选择国家": "请选择国家",
  "全名（名和姓）": "全名（名和姓）",
  "请输入您的名称": "请输入您的名称",
  "电话号码注意添加区号": "电话号码注意添加区号",
  "城市，区，街道，详细地址等": "城市，区，街道，详细地址等",
  "邮政区码": "邮政区码",
  "请输入邮政区码": "请输入邮政区码",
  "将此地址设为默认地址": "将此地址设为默认地址",
  "使用这个地址": "使用这个地址",
  "输入新的": "输入新的",
  "输入修改后的": "输入修改后的",
  "修改地址": "修改地址",
  //====================================协调方================================
  "货品订单": "货品订单",
  "货品协调订单": "货品协调订单",
  "需求协调订单": "需求协调订单",
  "需求方账号名称": "需求方账号名称",
  "协调费报价": "协调费报价",
  "开具协调证明": "开具协调证明",
  "协调证明标题": "协调证明标题",
  "运费报价": "运费报价",
  "需求订单": "需求订单",
  "账户设置": "账户设置",
  "协调费金额": "协调费金额",
  "请输入协调费金额": "请输入协调费金额",
  "协调员收货地址": "协调员收货地址",
  "已确认收到货物": "已确认收到货物",


  //====================================供应方-收款方式绑定================================
  "微信支付收款绑定": "微信支付收款绑定",
  "已绑定": "已绑定",
  "未绑定": "未绑定",
  "更改": "更改",
  "支付宝支付收款绑定": "支付宝支付收款绑定",
  "绑定": "绑定",
  "中国收款银行卡绑定": "中国收款银行卡绑定",
  "添加": "添加",
  "公司名称": "公司名称",
  "开户行": "开户行",
  "银行账号": "银行账号",
  "行号": "行号",
  "备注": "备注",
  // "单笔限额": "单笔限额",
  "万": "万",
  "账户名": "账户名",
  "国际收款银行卡绑定": "国际收款银行卡绑定",
  "收款人姓名": "收款人姓名",
  // "收款行所在国家（地区）": "收款行所在国家（地区）",
  "收款币种": "收款币种",
  "SWIFT代码": "SWIFT代码",
  "收款人账号": "收款人账号",
  "IBAN号": "IBAN号",
  "收款行标识": "收款行标识",
  "请输入开户支行行号": "请输入开户支行行号",
  // "本地清算号": "本地清算号",
  "收款行全称": "收款行全称",
  "收款行地址": "收款行地址",
  "设为默认": "设为默认",
  "收款银行卡": "收款银行卡",
  "银行卡类型": "银行卡类型",
  "个人银行账户": "个人银行账户",
  "银行名称": "银行名称",
  "请输入银行名称": "请输入银行名称",
  "请输入账户名": "请输入账户名",
  "输入开户支行名称": "输入开户支行名称",
  "请输入银行账号": "请输入银行账号",
  "请输入公司名称": "请输入公司名称",
  "输入备注，不超过200字": "输入备注，不超过200字",
  "请输入收款人姓名": "请输入收款人姓名",
  "收款行所在国家（地区）": "收款行所在国家（地区）",
  "请输入swift代码": "请输入swift代码",
  "请输入IBAN号": "请输入IBAN号",
  "请输入收款行标识": "请输入收款行标识",
  "请输入收款行全称": "请输入收款行全称",
  "请输入收款行地址": "请输入收款行地址",
  "微信与支付宝收款，点击绑定，用微信或支付宝扫描对应二维码，扫码后出现success文字后即代表绑定成功，手动刷新次此页面查看是否已变更为“已绑定”状态。需求方的在线支付将在确认收货后，平台结算给供应方。":"微信与支付宝收款，点击绑定，用微信或支付宝扫描对应二维码，扫码后出现success文字后即代表绑定成功，手动刷新次此页面查看是否已变更为“已绑定”状态。需求方的在线支付将在确认收货后，平台结算给供应方。",
  //====================================供应方-店铺内商品分类================================
  "分类名称": "分类名称",
  "排序值": "排序值",
  "添加时间": "添加时间",
  "修改": "修改",
  "下级分类": "下级分类",
  "下级分类名称": "下级分类名称",
  //====================================供应方-店铺信息修改================================
  "供应方商店头像": "供应方商店头像",
  "供应方商店主图": "供应方商店主图",
  "商店banner图": "商店banner图",
  "商店标签": "商店标签",
  "发货地址": "发货地址",
  "收货地址": "收货地址",
  "店铺简介": "店铺简介",
  "请输入店铺简介": "请输入店铺简介",
  //====================================供应方-案例管理================================
  "案例id": "案例id",
  "发布案例": "发布案例",
  "个案例": "个案例",
  "上架中的案例": "上架中的案例",
  "已下架的案例": "已下架的案例",
  "案例状态": "案例状态",
  "案例名称": "案例名称",
  "案例价格": "案例价格",
  "累计用时": "累计用时",
  "案例发生时间": "案例发生时间",
  "案例ID": "案例ID",
  "下架": "下架",
  "案例类目": "案例类目",
  "请选择案例类目": "请选择案例类目",
  // "案例标签": "案例标签",
  "请输入标签名称后点击“添加”": "请输入标签名称后点击“添加”",
  "案例主图": "案例主图",
  "案例简介": "案例简介",
  "请输入案例简介": "请输入案例简介",
  "案例详情": "案例详情",
  "提交并立刻上架": "提交并立刻上架",
  "存入已下架": "存入已下架",
  "案例轮播图": "案例轮播图",
  "请输入案例名称": "请输入案例名称",
  "发布": "发布",
  "上架中": "上架中",
  "已下架": "已下架",
  //====================================供应方-订单管理================================
  "待供应商收货": "待供应商收货",
  "退款/售后": "退款/售后",
  "修改订单价格": "修改订单价格",
  "关闭订单": "关闭订单",
  "选择协调服务": "选择协调服务",
  "查看收货地址": "查看收货地址",
  "填写物流信息": "填写物流信息",
  "运费确认": "运费确认",
  "确认退款": "确认退款",
  "发货": "发货",
  "物流公司": "物流公司",
  "请输入发货物流公司": "请输入发货物流公司",
  "物流方式": "物流方式",
  "请输入发货物流方式": "请输入发货物流方式",
  "图片": "图片",
  "确认": "确认",
  "订单改价金额": "订单改价金额",
  "订单结算金额": "订单结算金额",
  "请输入您更改后的订单结算金额": "请输入您更改后的订单结算金额",

  //====================================供应方-我的投标================================
  "个投标": "个投标",
  "需求信息": "需求信息",
  "中标信息": "中标信息",
  "付款信息": "付款信息",
  "协调员": "协调员",
  "需求发布时间": "需求发布时间",
  "需求发布金额": "需求发布金额",
  "个供应商参与": "个供应商参与",
  "中标供应方": "中标供应方",
  "合同金额": "合同金额",
  "查看详情": "查看详情",
  "订单选择的协调服务": "订单选择的协调服务",
  "确认终止合作": "确认终止合作",
  "终止合作": "终止合作",
  "验收资料上传": "验收资料上传",
  "签署合同": "签署合同",
  "合同金额报价": "合同金额报价",
  "合同报价": "合同报价",
  "请输入合同金额": "请输入合同金额",
  "输入合同总金额": "输入合同总金额",
  "合同金额确认": "合同金额确认",
  "确认合作": "确认合作",
  "合同": "合同",
  "我的中标": "我的中标",
  //====================================参与投标弹框================================
  "参与投标/投聘": "参与投标/投聘",
  "请上传相关投标文件": "请上传相关投标文件",
  "序号": "序号",
  "附件": "附件",
  "返回结果": "返回结果",
  "附件下载": "附件下载",
  "留言板": "留言板",
  //====================================供应方-需求卡片================================
  "需求ID": "需求ID",
  "招标中/招聘中": "招标中/招聘中",
  "参与投标数量": "参与投标数量",
  "需求完成时间": "需求完成时间",
  //====================================搜索结果================================
  "产品": "产品",
  "需求": "需求",
  "结果": "结果",
  "查看每个商品页面以了解其他购买选项，价格和其他详情可能因商品尺寸和颜色而异": "查看每个商品页面以了解其他购买选项，价格和其他详情可能因商品尺寸和颜色而异",
  "查看每个供应商的商店来了解他们的其他商品": "查看每个供应商的商店来了解他们的其他商品",
  "查看每个案例页面并发现更多供应商相关案例": "查看每个案例页面并发现更多供应商相关案例",
  "共超过": "共超过",
  "服务": "服务",
  "价格：从低到高": "价格：从低到高",
  "价格：从高到低": "价格：从高到低",
  "销量：从低到高": "销量：从低到高",
  "销量：从高到低": "销量：从高到低",
  "评分：从低到高": "评分：从低到高",
  "最新案例": "最新案例",
  "条搜索结果": "条搜索结果",
  "最新商品": "最新商品",
  "综合排序(随机排序)": "综合排序(随机排序)",
  "需求状态": "需求状态",
  "排序方式": "排序方式",
  "查看每个需求以了解其他信息": "查看每个需求以了解其他信息",
  //====================================发布需求================================
  "需求名称": "需求名称",
  "请输入需求名称": "请输入需求名称",
  "需求类目": "需求类目",
  "招标产品": "招标产品",
  "招聘": "招聘",
  "请选择需求类目": "请选择需求类目",
  "需求总金额": "需求总金额",
  "需求总金额报价": "需求总金额报价",
  "输入需求总金额": "输入需求总金额",
  "请输入需求总金额": "请输入需求总金额",
  "查看今日汇率": "查看今日汇率",
  "协调服务": "协调服务",
  "不选择协调服务": "不选择协调服务",
  // "请选择协调服务": "请选择协调服务",
  "协调服务说明": "协调服务说明",
  "招标时间段": "招标时间段",
  "比选结果公示时间必须在招标结束时间之后": "比选结果公示时间必须在招标结束时间之后",
  "至": "至",
  "比选结果公示时间": "比选结果公示时间",
  "选择日期": "选择日期",
  "定金": "定金",
  "尾款": "尾款",
  "附件上传": "附件上传",
  "上传": "上传",
  "只能上传图片文件": "只能上传图片文件",
  "需求主图": "需求主图",
  "投标要求": "投标要求",
  "请输入投标要求": "请输入投标要求",
  "需求介绍": "需求介绍",
  "需求轮播图": "需求轮播图",
  "最多上传 6 张": "最多上传 6 张",
  "请输入内容": "请输入内容",
  "百分比": "百分比",
  "金额": "金额",
  "请选择招标时间段": "请选择招标时间段",
  // "请选择招标截止日期": "请选择招标截止日期",
  "请选择定金支付方式": "请选择定金支付方式",
  "请选择比选结果公示日期": "请选择比选结果公示日期",
  "请输入定金": "请输入定金",

  //====================================我的购物================================
  "全部": "全部",
  "待供应方选择协调员": "待供应方选择协调员",
  "待协调员接单": "待协调员接单",
  "待供应商发货": "待供应商发货",
  "个订单": "个订单",
  "最近": "最近",
  "天": "天",
  "刷新": "刷新",
  "请选择": "请选择",
  "商品名称": "商品名称",
  "商品ID": "商品ID",
  "供应方账号名称": "供应方账号名称",
  "协调员账号名称": "协调员账号名称",
  "付款时间": "付款时间",
  "交易人员信息": "交易人员信息",
  "商品信息": "商品信息",
  "评价": "评价",
  "分值": "分值",
  "评价内容": "评价内容",
  "删除评价": "删除评价",
  "确认删除评价": "确认删除评价",
  "协调证明": "协调证明",
  "暂无协调证明": "暂无协调证明",
  "暂无图片": "暂无图片",
  "订单状态": "订单状态",
  "系统提示": "系统提示",
  "操作": "操作",
  "订单号": "订单号",
  "创建时间": "创建时间",
  "需求方协调订单": "需求方协调订单",
  "需求方名称": "需求方名称",
  "协调员名称": "协调员名称",
  "查看": "查看",
  "待管理端确认银行卡收款": "待管理端确认银行卡收款",
  "取消订单": "取消订单",
  "订单追踪": "订单追踪",
  "确认收货": "确认收货",
  "退款": "退款",
  "支付订单": "支付订单",
  "确认取消订单": "确认取消订单",
  "取消": "取消",
  "确定": "确定",
  "待供应方选择协调服务": "待供应方选择协调服务",
  "待协调员接单(后台指派协调员)": "待协调员接单(后台指派协调员)",
  "待供应方收货(协调员发现商品质量不合格,退回给供应方)": "待供应方收货(协调员发现商品质量不合格,退回给供应方)",
  "供应方协调订单":"供应方协调订单",
  "是否产生运费":"是否产生运费",
  //====================================需求方================================
  "认证名称不能为空": "认证名称不能为空",
  "请上传证件图片": "请上传证件图片",
  "请上传合同章/签章": "请上传合同章/签章",
  "需求方认证请上传合同章/签章": "请上传合同章/签章",
  "需求方认证": "需求方认证",
  "需求方认证名称": "需求方认证名称",
  "需求类型": "需求类型",
  "是否公开": "是否公开",
  "公开": "公开",
  "私密": "私密",
  "请选择是否公开": "请选择是否公开",
  "您希望在平台解决什么类型的需求": "您希望在平台解决什么类型的需求",
  //====================================需求方--我的需求================================
  "比选中": "比选中",
  "待供应方确认": "待供应方确认",
  "待平台确认": "待平台确认",
  "合同签订中": "合同签订中",
  "进行中": "进行中",
  "已完成": "已完成",
  "已关闭": "已关闭",
  "中标供应方名称": "中标供应方名称",
  "联系人": "联系人",
  "协调费确认": "协调费确认",
  "协调费": "协调费",
  "协调费合计": "协调费合计",
  "协调费报价中": "协调费报价中",
  "请输入您拒绝的原因": "请输入您拒绝的原因",
  "输入拒绝原因": "输入拒绝原因",
  "拒绝": "拒绝",
  "付款": "付款",
  "关闭需求": "关闭需求",
  "确认关闭需求": "确认关闭需求",
  "投标供应方": "投标供应方",
  "重新报价": "重新报价",
  "支付定金": "支付定金",
  "验收资料下载": "验收资料下载",
  "支付尾款": "支付尾款",
  "请选择支付方式": "请选择支付方式",
  "个供应方投标": "个供应方投标",
  "参与投标时间": "参与投标时间",
  "供应方主页": "供应方主页",
  "下载投标文件": "下载投标文件",
  "中标": "中标",
  "是否确认": "是否确认",
  "供应方为最终中标供应方，并以如下价格意向进行合作": "供应方为最终中标供应方，并以如下价格意向进行合作",
  "自行上传合同": "自行上传合同",
  "使用平台合同": "使用平台合同",
  "仅支持pdf格式": "仅支持pdf格式",
  "为保障您的权益，您支付的定金将由迈丝官方保管，直至完成后结算给供应方": "为保障您的权益，您支付的定金将由迈丝官方保管，直至完成后结算给供应方",
  "需求价格": "需求价格",
  "银行卡支付": "银行卡支付",
  "平台合同预览": "平台合同预览",
  "请选择付款方式": "请选择付款方式",
  "上传合同": "上传合同",
  "重置": "重置",
  "确认签署": "确认签署",
  "下载": "下载",
  "运费": "运费",
  "商品金额": "商品金额",
  "退款原因": "退款原因",

  //====================================协调员================================
  "成为协调员": "成为协调员",
  "姓名": "姓名",
  "请输入您的姓名": "请输入您的姓名",
  "上传个人证件证明": "上传个人证件证明",
  "签章": "签章",
  "上传PNG无背景格式的个人签章": "上传PNG无背景格式的个人签章",
  //====================================供应方认证================================
  "成为供应方": "成为供应方",
  "供应方认证名称": "供应方认证名称",
  "请输入个人或企业名称": "请输入个人或企业名称",
  "请输入": "请输入",
  "供应行业类目": "供应行业类目",
  "请选择供应行业类目": "请选择供应行业类目",
  "证件认证": "证件认证",
  "上传个人证件证明 或 企业营业执照": "上传个人证件证明 或 企业营业执照",
  "擅长技能或供应货品类型": "擅长技能或供应货品类型",
  "合同章/签章": "合同章/签章",
  "上传PNG无背景格式的企业合同章签章或个人签章": "上传PNG无背景格式的企业合同章签章或个人签章",
  "供应方名称": "供应方名称",
  "顾客将会通过供应方名称搜索到你的店铺": "顾客将会通过供应方名称搜索到你的店铺",
  "提交资料": "提交资料",
  "点击": "点击",
  "即代表您已阅读并同意我们的": "即代表您已阅读并同意我们的",
  "需求方服务协议": "需求方服务协议",
  "协调方服务协议": "协调方服务协议",
  "供应方服务协议": "供应方服务协议",
  "消费者保障服务协议": "消费者保障服务协议",
  "丝迈网商支付服务协议": "丝迈网商支付服务协议",
  //====================================忘记密码================================
  "忘记密码": "忘记密码",
  "手机号": "手机号",
  "验证码": "验证码",
  "获取验证码": "获取验证码",
  "密码": "密码",
  "新密码": "新密码",
  "继续": "继续",
  //====================================创建账户================================
  "创建账户": "创建账户",
  "已有账户": "已有账户",
  "请输入手机号": "请输入手机号",
  "请输入验证码": "请输入验证码",
  "请输入密码": "请输入密码",
  "请输入账号名称": "请输入账号名称",
  "请输入姓氏": "请输入姓氏",
  "请输入名": "请输入名",
  "请选择性别": "请选择性别",
  "请输入账号所属区": "请输入账号所属区",
  "请输入国家": "请输入国家",
  "请输入城市": "请输入城市",
  "请输入邮政编码": "请输入邮政编码",
  "请输入邮箱地址": "请输入邮箱地址",
  "请输入地址": "请输入地址",
  "请输入微信号": "请输入微信号",
  "请输入传真": "请输入传真",
  "请输入QQ号": "请输入QQ号",
  "更改邮箱": "更改邮箱",
  // "点击创建账户即代表您已阅读并同意我们的 用户协议，用户隐私协议，法律声明，丝迈平台服务协议。": "点击创建账户即代表您已阅读并同意我们的 用户协议，用户隐私协议，法律声明，丝迈平台服务协议。",
  //====================================登录/注册================================
  "请输入邮箱地址或手机号": "请输入邮箱地址或手机号",
  "以“需求方”的身份登录": "以“需求方”的身份登录",
  "以“供应方”的身份登录": "以“供应方”的身份登录",
  "以“协调员”的身份登录": "以“协调员”的身份登录",
  "登录操作即表示您已阅读并同意我们的": "登录操作即表示您已阅读并同意我们的",
  // "用户协议， 用户隐私协议，法律声明，丝迈平台服务协议": "用户协议， 用户隐私协议，法律声明，丝迈平台服务协议",
  "丝迈交易平台新用户": "丝迈交易平台新用户",
  "创建您的丝迈交易平台账户": "创建您的丝迈交易平台账户",
  "当前登录身份资料审核中": "当前登录身份资料审核中",
  "账号不能为空": "账号不能为空",
  "密码不能为空": "密码不能为空",
  "请选择登录身份": "请选择登录身份",
  "登录失败": "登录失败",
  "登录中": "登录中",
  "关闭": "关闭",
  "您的姓名": "您的姓名",
  "电话号码": "电话号码",
  "电子邮件": "电子邮件",
  "账号所属区": "账号所属区",
  "再次输入密码": "再次输入密码",
  "验证邮箱": "验证邮箱",
  "用户协议": "用户协议",
  "用户隐私协议": "用户隐私协议",
  "法律声明": "法律声明",
  "丝迈平台服务协议": "丝迈平台服务协议",
  "已拥有账户": "已拥有账户",
  "无法上传更多图片": "无法上传更多图片",
  "验证码已发送至您的手机号码": "验证码已发送至您的手机号码",
  "重新发送验证码": "重新发送验证码",
  "请选择您所生活或主要提供服务的区域，这非常重要": "请选择您所生活或主要提供服务的区域，这非常重要",
  "密码至少包含八个字符，其中至少包含一个数字，并 包含 小写字母、大写字母和特殊字符": "密码至少包含八个字符，其中至少包含一个数字，并 包含 小写字母、大写字母和特殊字符",
  "为了您的安全，我们已将代码发送到您的邮箱": "为了您的安全，我们已将代码发送到您的邮箱",
  "为了您的安全，我们将通过代码发送到您的邮箱": "为了您的安全，我们将通过代码发送到您的邮箱",
  "发送验证码": "发送验证码",
  "返回": "返回",
  "两次密码输入不一致": "两次密码输入不一致",
  "请确认密码": "请确认密码",
  "提交代码": "提交代码",
  "请输入有效的电子邮件": "请输入有效的电子邮件",
  "请输入您的名字": "请输入您的名字",
  "请输入有效的手机号码": "请输入有效的手机号码",
  "输入密码": "输入密码",
  "我们找不到具有该电子邮件地址或手机号码的账号": "我们找不到具有该电子邮件地址或手机号码的账号",
  "密码输入错误": "密码输入错误",
  "当前身份申请未通过，未通过原因": "当前身份申请未通过，未通过原因",
  "当前账号不是“供应方”，您希望成为“供应方”吗？": "当前账号不是“供应方”，您希望成为“供应方”吗？",
  "当前账号不是“协调员”，您希望成为“协调员”吗？": "当前账号不是“协调员”，您希望成为“协调员”吗？",
  "输入验证码": "输入验证码",
  "密码帮助": "密码帮助",
  "输入与您的 丝迈交易平台 账户相关联的邮箱": "输入与您的 丝迈交易平台 账户相关联的邮箱",
  "请输入手机号码": "请输入手机号码",
  "输入新密码": "输入新密码",
  "提交新密码": "提交新密码",
  "超管登录": "超管登录",
  "超管账号": "超管账号",
  "超管密码": "超管密码",
  //====================================顶部导航================================
  "丝迈交易平台": "丝迈交易平台",
  "中文": "中文",
  "英文": "英文",
  "中国区": "中国区",
  "国际区": "国际区",
  "搜索": "搜索",
  "商品": "商品",
  "供应商": "供应商",
  "案例": "案例",
  "发布需求": "发布需求",
  "登录": "登录",
  "注册": "注册",
  "或": "或",
  "我的订单统计": "我的订单统计",
  "需求订单统计": "需求订单统计",
  "订单状态统计": "订单状态统计",
  "查看更多": "查看更多",
  "待需求方付款": "待需求方付款",
  "协调费协商中": "协调费协商中",
  "拒绝原因": "拒绝原因",
  "待供应方发货": "待供应方发货",
  "待协调员收货": "待协调员收货",
  "协调员已收货": "协调员已收货",
  "运费协商中": "运费协商中",
  "待需求方收货": "待需求方收货",
  "待需求方评价": "待需求方评价",
  "我的账户": "我的账户",
  "我的购物": "我的购物",
  "我的需求": "我的需求",
  "个人资料": "个人资料",
  "我的认证": "我的认证",
  "修改密码": "修改密码",
  "退出": "退出",
  "切换身份": "切换身份",
  "已认证": "已认证",
  "已拒绝": "已拒绝",
  "审核中": "审核中",
  "未认证": "未认证",
  "立即登录": "立即登录",
  "新客户": "新客户",
  "免费注册": "免费注册",
  "我的投标": "我的投标",
  "中标订单": "中标订单",
  "请输入留言": "请输入留言",
  "回复": "回复",
  "发布人": "发布人",
  "发送": "发送",
  "发送成功": "发送成功",
  "不需要协调服务": "不需要协调服务",
  "操作失败": "操作失败",
  "最新需求": "最新需求",
  //====================================我的认证================================
  "重新认证": "重新认证",
  "性别": "性别",
  "地址": "地址",
  "联系方式": "联系方式",
  "名称": "名称",
  "国家": "国家",
  "城市": "城市",
  "邮箱": "邮箱",
  "邮政编码": "邮政编码",
  "保存": "保存",
  "操作成功": "操作成功",
  "复制链接成功": "复制链接成功",
  "复制失败": "复制失败",
  "请先使用供应方身份登录": "请先使用供应方身份登录",
  "当前登录账号是以{role}身份登录的，需要用供应方身份登录": "当前登录账号是以{role}身份登录的，需要用供应方身份登录",
  "当前登录账号是以{role}身份登录的，需要切换到供应方身份": "当前登录账号是以{role}身份登录的，需要切换到供应方身份",
  "提示": "提示",
  "游客": "游客",
  "超管": "超管",
  "注册成功": "注册成功",
  "上传签章图片只能是 PNG 格式": "上传签章图片只能是 PNG 格式",
  "上传失败": "上传失败",
  "上传文件必须是图片": "上传文件必须是图片",
  "文件上传成功": "文件上传成功",
  //====================================我的店铺================================
  "我的店铺": "我的店铺",
  "ID": "ID",
  "耐克丝迈官方店": "耐克丝迈官方店",
  "耐克（中国）股份有限公司": "耐克（中国）股份有限公司",
  "今日新增订单": "今日新增订单",
  "今日订单收益": "今日订单收益",
  "过去一个月订单": "过去一个月订单",
  "过去一个月订单收益": "过去一个月订单收益",
  "中国区店铺": "中国区店铺",
  "营业中": "营业中",
  "已禁用": "已禁用",
  "进入店铺": "进入店铺",
  "店铺标签": "店铺标签",
  "默认物流配送方式": "默认物流配送方式",
  "默认收货地址": "默认收货地址",
  "默认发货地址": "默认发货地址",
  "商品管理": "商品管理",
  "案例管理": "案例管理",
  "店铺信息修改": "店铺信息修改",
  "收款方式绑定": "收款方式绑定",
  "店铺内商品分类": "店铺内商品分类",
  "店铺内案例分类": "店铺内案例分类",
  "订单管理": "订单管理",
  "我的案例": "我的案例",
  "需求方": "需求方",
  "需求方/招标/招聘": "需求方/招标/招聘",
  "供应方": "供应方",
  "供应方/投标/投聘":"供应方/投标/投聘",
  "协调方": "协调方",
  "商店类目": "商店类目",
  "个需求成功交易": "个需求成功交易",
  "查看商品": "查看商品",
  "查看案例": "查看案例",
  "所有商品分类": "所有商品分类",
  "所有案例分类": "所有案例分类",
  "搜索商品名称": "搜索商品名称",
  "所有商品": "所有商品",
  "搜索案例名称": "搜索案例名称",
  "所有案例": "所有案例",
  //====================================我的店铺-商品管理================================
  "商品id": "商品id",
  "发布商品": "发布商品",
  "出售中的商品": "出售中的商品",
  "出售中": "出售中",
  "已下架的商品": "已下架的商品",
  "个商品": "个商品",
  "商品类型": "商品类型",
  "商品标题": "商品标题",
  "商品SKU": "商品SKU",
  "商品价格": "商品价格",
  "总库存": "总库存",
  "商品SKU编码": "商品SKU编码",
  "商品状态": "商品状态",
  "下架时间": "下架时间",
  "商品展示价": "商品展示价",
  "展示原价": "展示原价",
  "编辑": "编辑",
  "上架": "上架",
  "删除": "删除",
  "添加规格": "添加规格",
  "主规格": "主规格",
  "副规格": "副规格",
  "库存不能小于0": "库存不能小于0",
  "请添加销售属性": "请添加销售属性",
  "请添加销售规格": "请添加销售规格",
  "请输入商品标题": "请输入商品标题",
  "商品类目": "商品类目",
  "请选择商品类目": "请选择商品类目",
  "店铺内分类": "店铺内分类",
  "请选择店铺内分类": "请选择店铺内分类",
  "商品属性": "商品属性",
  "请输入商品的各项关键属性信息": "请输入商品的各项关键属性信息",
  "销售属性": "销售属性",
  "销售规格": "销售规格",
  "售价": "售价",
  "请输入售价": "请输入售价",
  "原价": "原价",
  "请输入原价": "请输入原价",
  "库存": "库存",
  "请输入库存": "请输入库存",
  "SKU编码": "SKU编码",
  "请输入SKU编码": "请输入SKU编码",
  "规格展示图": "规格展示图",
  "请选择商品类型": "请选择商品类型",
  "请输入商品展示价": "请输入商品展示价",
  "商品原价": "商品原价",
  "请输入商品原价": "请输入商品原价",
  "库存规则": "库存规则",
  "拍下减库存": "拍下减库存",
  "商品详情": "商品详情",
  "详情": "详情",
  "禁用": "禁用",
  "热门评论": "热门评论",
  "最新评论": "最新评论",
  "来自全球的评论": "来自全球的评论",
  "有用": "有用",
  "感谢您的反馈": "感谢您的反馈",
  //====================================商品详情================================
  "参观": "参观",
  "的商店": "的商店",

  //====================================底部================================
  '深红未来(深圳)科技有限公司':'深红未来(深圳)科技有限公司',
  '苏ICP备2025171803号-1':'苏ICP备2025171803号-1',
  '深公网安备 33011002011859号':'深公网安备 33011002011859号',
  '请输入拒绝原因':'请输入拒绝原因',
  '协调方收货地址':'协调方收货地址',
  '需求方收货地址':'需求方收货地址',
  '是否有物流':'是否有物流',
  '退款确认':'退款确认',
  '请选择收货地址':'请选择收货地址',
  '为保障您的权益，您支付的金额将会由深红官方保管，直至完成后结算给供应方':'为保障您的权益，您支付的金额将会由深红官方保管，直至完成后结算给供应方',
  '无':'无',
  '有':'有',
  '请先登录':'请先登录',
  '是否协调订单':'是否协调订单',
  '是':'是',
  '否':'否',
  "最近7天":"最近7天",
  "最近30天":"最近30天",
  "等待需求方付款":"等待需求方付款",
  "等待供应方选择协调服务":"等待供应方选择协调服务",
  "待协调方接单":"待协调方接单",
  "等待供应方发货":"等待供应方发货",
  "待协调方收货":"待协调方收货",
  "协调方已收货":"协调方已收货",
  "待收货":"待收货",
  "等待需求方评价":"等待需求方评价",
  "订单创建成功，请等待供应方更改价格，如价格无变动，则等待平台确认商品金额到账":  "订单创建成功，请等待供应方更改价格，如价格无变动，则等待平台确认商品金额到账",
  "请线下银行卡转账成功后等待丝迈官方确认收款":"请线下银行卡转账成功后等待丝迈官方确认收款",
  "确认关闭订单":"确认关闭订单",
  "添加下一页":"添加下一页",
  "管理店铺": "管理店铺",
  "立即购买": "立即购买",
  "上一页": "上一页",
  "售价不能为空": "售价不能为空",
  "原价不能为空": "原价不能为空",
  "库存不能为空": "库存不能为空",
  "SKU编码不能为空": "SKU编码不能为空",
  "存在重复的SKU编码": "存在重复的SKU编码",
  "丝迈交易平台管理端": "丝迈交易平台管理端",
  "远程登录": "远程登录",
  "账号权限验证": "账号权限验证",
  "验证": "验证",
  "申请访问": "申请访问",
  "申请成功，请耐心等待审核": "申请成功，请耐心等待审核",
  "只能上传PNG格式的图片": "只能上传PNG格式的图片",
  "所在页面": "所在页面",
  "x坐标": "x坐标",
  "Y坐标": "Y坐标",
  "查看评价": "查看评价",
  "官方": "官方",
  "配送": "配送",
  "全选": "全选",
  "验收资料": "验收资料",
  "请选择发货地址": "请选择发货地址",
  "协调方认证": "协调方认证",
  "协调方认证名称": "协调方认证名称",
  "供应方店铺名称": "供应方店铺名称",
  "店铺": "店铺",
  "闭店": "闭店",
  "营业": "营业",
  "已打烊": "已打烊",
  "新增": "新增",
  "二级分类": "二级分类",
  "二级分类名称": "二级分类名称",
  "请输入二级分类名称": "请输入二级分类名称",
  "请输入排序值": "请输入排序值",
  "一级分类": "一级分类",
  "一级分类名称": "一级分类名称",
  "请输入一级分类名称": "请输入一级分类名称",
  "商品标签": "商品标签",
  "商品主图": "商品主图",
  "案例标签": "案例标签",
  "请至少选择一项": "请至少选择一项",
  "中国个人收款银行卡绑定": "中国个人收款银行卡绑定",
  "中国企业收款银行卡绑定": "中国企业收款银行卡绑定",
  "是否设为默认": "是否设为默认",
  "需求双方合同签订后，需要支付定金": "需求双方合同签订后，需要支付定金",
  "需求在招标阶段展示的金额，不是最终合同金额，可以填“面议”": "需求在招标阶段展示的金额，不是最终合同金额，可以填“面议”",
  "男": "男",
  "女": "女",
  "时间": "时间",
  // 下面需要翻译
  "需求方提供的需求总金额": "需求方提供的需求总金额",
  "需求方已选择协调服务": "需求方已选择协调服务",
  "拒绝这个报价": "拒绝这个报价",
  "收货时间": "收货时间",
  "请输入备注": "请输入备注",
  "确认报价": "确认报价",
  "确认合同": "确认合同",
  "需求方合同金额报价": "需求方合同金额报价",
  "确认合同金额": "确认合同金额",
  "合同签章": "合同签章",
  "将合同签章拖到文件相应位置": "将合同签章拖到文件相应位置",
  "请先上传签章": "请先上传签章",
  "签章图片加载失败，请重新上传": "签章图片加载失败，请重新上传",
  "签署失败，请稍后重试": "签署失败，请稍后重试",
  "印章": "印章",
  "合计": "合计",
  "状态": "状态",
  "请补充必填项": "请补充必填项",
  "微信扫码授权": "微信扫码授权",
  "支付宝扫码授权": "支付宝扫码授权",
  "请使用微信扫描二维码完成授权": "请使用微信扫描二维码完成授权",
  "请使用支付宝扫描二维码完成授权": "请使用支付宝扫描二维码完成授权",
  "请扫码支付": "请扫码支付",
  "支付宝暂不可用": "支付宝暂不可用",
  "请输入详情内容": "请输入详情内容",
  "请输入电话号码": "请输入电话号码",
  "为保障您的权益，您支付的定金将由迈丝官方保管，直至项目完成后再同尾款一起结算给供应方": "为保障您的权益，您支付的定金将由迈丝官方保管，直至项目完成后再同尾款一起结算给供应方",
  "您可以修改此价格来表达你的合作价格意向": "您可以修改此价格来表达你的合作价格意向",
  "修改价格": "修改价格",
}




// WEBPACK FOOTER //
// ./src/language/zh.js